import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="12" height="8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.289.71L.699 5.3a.996.996 0 101.41 1.41l3.89-3.88 3.88 3.88a.996.996 0 101.41-1.41L6.699.71a.996.996 0 00-1.41 0z" fill="#07A" /></svg>;